import { getCookies } from 'cookies-next'
import jwt from 'jsonwebtoken'
import fetch from 'cross-fetch'
import createConfig from '../../site.config'

const appendUser = async (pageData, context, instance) => {
  // Get the user & their access list (maybe should be middleware)
  const cookies = context.req?.headers.cookie
  if (cookies) {
    // https://tinypass.atlassian.net/wiki/spaces/CXPLATPUBLIC/pages/3284795972/API+authentication
    const parsedCookies = getCookies({
      req: context.req,
      res: context.res
    })
    const userCookie = parsedCookies.__utp
    const decodedCookie = jwt.decode(userCookie)
    if (decodedCookie) {
      pageData.user = decodedCookie
      const params = new URLSearchParams()
      params.append('aid', instance.pianoApplicationId)
      params.append('uid', pageData.user.sub)
      params.append('api_token', instance.pianoApiToken)
      const pianoApiPath = createConfig(instance).piano.apiPath
      const accessResponse = await fetch(
        `${pianoApiPath}/publisher/user/access/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: params
        }
      )
      const accessData = await accessResponse.json()
      if (accessData.code === 0) pageData.user.accessList = accessData.accesses
    }
  }
  return pageData
}

export default appendUser
